import { render } from "./TeacherProfile.vue?vue&type=template&id=75270ccc&scoped=true"
import script from "./TeacherProfile.vue?vue&type=script&lang=js"
export * from "./TeacherProfile.vue?vue&type=script&lang=js"

import "./TeacherProfile.vue?vue&type=style&index=0&id=75270ccc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75270ccc"]])

export default __exports__